/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Simple/Data/validate.js'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsCardWrite/Name",
  onChange,
  isSubmitting,
  isValid,
  isInvalid
  
}) {
let txCardFieldDefinitionNameValueData = fromData.useDataValue({ viewPath,
context: 'tx_card_field_definition',
path: 'name',
})
let txCardFieldDefinitionNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'tx_card_field_definition',
path: 'name',
validate: fromValidate.textAtLeastOneChar,
required: true,
})
let txCardFieldDefinitionNameChangeData = fromData.useDataChange({ viewPath,
context: 'tx_card_field_definition',
path: 'name',
})
let txCardFieldDefinitionNameIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'tx_card_field_definition',
})
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 marginTop={0}
 label="Name"
 data="tx_card_field_definition.name"
 value={txCardFieldDefinitionNameValueData}
 onChange={txCardFieldDefinitionNameChangeData}
 disabled={txCardFieldDefinitionNameIsSubmittingData}
 required={true}
 validate="/Simple/Data/validate.js textAtLeastOneChar"
 valid={txCardFieldDefinitionNameIsValidData}
 invalid={!txCardFieldDefinitionNameIsValidData}
/>
{children}
</React.Fragment>)
}